import React from 'react';
import PropTypes from 'prop-types';
import { Link, Icon, grey600 } from '@paypalcorp/pp-react';

function SocialShareFacebook({ url, handleSocialLinkClick, linkTitle }) {
  return (
    <Link
      href={url}
      target="popup"
      onClick={() => handleSocialLinkClick(url, 'facebook')}
      title={linkTitle}
      style={{ color: grey600 }}
      data-testid="social-share-facebook"
    >
      <Icon name="share-facebook" size="lg" />
    </Link>
  );
}

SocialShareFacebook.propTypes = {
  url: PropTypes.string,
  handleSocialLinkClick: PropTypes.func,
  linkTitle: PropTypes.string,
};

export default SocialShareFacebook;
